import { Head, Image, Split } from 'mdx-deck';
import { prism } from '@mdx-deck/themes';
import { CodeSurfer } from "code-surfer";
import { nightOwl as codeSurferNightOwl } from "@code-surfer/themes";
import prismNightOwl from '@theme-ui/prism/presets/night-owl';
import Prism from '@theme-ui/prism';
import argOptionalPng from "..\\..\\..\\..\\..\\..\\slides\\arg-optional.png";
import strongerReturnPng from "..\\..\\..\\..\\..\\..\\slides\\stronger-return.png";
import React from 'react';
export default {
  Head: Head,
  Image: Image,
  Split: Split,
  prism: prism,
  CodeSurfer: CodeSurfer,
  codeSurferNightOwl: codeSurferNightOwl,
  prismNightOwl: prismNightOwl,
  Prism: Prism,
  argOptionalPng: argOptionalPng,
  strongerReturnPng: strongerReturnPng,
  React: React
};